import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    forceRight: Boolean,
    offset: String
  }

  connect() {
    // Hide element immediately to prevent any visual flash when repositioning
    this.element.style.opacity = '0';

    // Need to wait until next tick before we can get proper dimensions
    setTimeout(() => { this.adjustPosition(); }, 10)
  }

  adjustPosition() {
    const menu = this.element;
    const parent = menu.parentElement;
    const menu_rect = menu.getBoundingClientRect();
    const parent_rect = parent.getBoundingClientRect();
    const viewport_width = window.innerWidth;
    const offset = (this.hasOffsetValue) ? this.offsetValue : '0rem'

    // Can't use left_class/right_class because offsets are arbitrary
    // and so tailwind doesn't know about them.
    menu.style.left = '';
    menu.style.right = '';

    if (this.forceRightValue) {
      menu.style.right = offset;
    } else if (parent_rect.left + menu_rect.width > viewport_width) {
      menu.style.right = offset;
    } else if (parent_rect.right - menu_rect.width < 0) {
      menu.style.left = offset;
    } else {
      menu.style.left = offset;
    }

    // Show element after positioning
    this.element.style.opacity = '1';
  }
}
